require('./bootstrap');

import $ from 'jquery';
import select2 from 'select2';
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

window.jQuery = $;
window.$ = $;
window.select2 = select2;
window.iziToast = require("izitoast");

require('./asset/summernote/summernote-bs4.min');
require('./asset/bootstrap/bootstrap.bundle.min');

window.initializeDatePicker = function () {
    flatpickr(".datepicker", {
        dateFormat: "Y-m-d",
        allowInput: true
    });
};
$(document).ready(function () {

    window.getParameterByName = function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return '';
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    /*
    * Copy content
    * */
    $(document).on('click', '.copy-content', function () {
        let id = $(this).data('id'),
            htmlContent = $(`#content-${id}`).html();

        navigator.clipboard.writeText(htmlContent)
            .then(() => {
                iziToast.success({
                    title: 'Copied',
                    message: 'Content successfully copied.'
                });
            })
            .catch(err => {
                iziToast.error({
                    title: 'Error!',
                    message: err
                });
            });
    });

    setTimeout(() => $('#successMessage, #warningMessage, #dangerMessage').fadeOut('slow'), 3000);

    const listingRoute = $('#table-content').attr('data-listing_url');

    window.load_records = function (page) {
        let search = $('#search').val(),
            query = window.getParameterByName("slug"),
            pagination = $('#paginationSelect').val();
        $('.query').addClass('d-none');
        if (query !== undefined && query != '') {
            $('.query').removeClass('d-none').html(`<strong>Showing Result:</strong> Category / ${query}`);
        }

        const listingRoute = $('#table-content').data('listing_url');

        if (listingRoute !== undefined) {
            let url = listingRoute + '?pagination=' + pagination + '&search=' + search + '&page=' + page + '&slug=' + query;
            axios.get(url).then((response) => {
                const { table_content, total } = response.data;
                $('#table-content').html(table_content);
                $('.total-count').html(total);
            });
        }
    };

    $('#paginationSelect').change(function () {
        load_records(1);
    });

    load_records(1);

    $(document).on('click', '.page-item:not(.active) .page-link', function (e) {
        e.preventDefault();
        let page = $(this).attr('href').split('page=')[1];
        load_records(page);
    });

    $('#paginationForm').submit(function (event) {
        event.preventDefault();
        load_records(1);
    });

    // $(document).on('click', '.page-item:not(.active) .page-link', function (e) {
    //     e.preventDefault();
    //     load_records(null, $(this).prop('href'));
    // });

    $(document).on('input keyup', '#search', function (event) {
        if (!$(this).val() || event.key === 'Enter') {
            load_records(1);
            history.replaceState(null, null, window.location.pathname);
            $('.query').addClass('d-none');
        }
    });

    window.initializeSummerNote = function () {
        $('.summernote').summernote({
            disableResizeEditor: true,
            height: 300,
            placeholder: 'Enter Text Here..',
            codemirror: {
                theme: 'monokai'
            },
            toolbar: [['style', ['bold', 'italic', 'underline', 'clear']], ['font', ['strikethrough', 'superscript', 'subscript']], ['fontname', ['fontname']], ['fontsize', ['fontsize']], ['color', ['color']], ['para', ['ul', 'ol', 'paragraph']], ['insert', ['picture']], ['height', ['height']]]
        });
    };
    initializeSummerNote();

    window.formatState = function (option) {
        const optionImage = $(option.element).attr('data-image');
        if (!optionImage) {
            return option.text;
        }

        return $(`<span><img height="19" width="19" src="${optionImage}" class="option-flag-image" />${option.text}</span>`);
    };

    window.reinitializedMultipleSelect2 = function () {
        $('.select2-multiple').select2({
            width: '100%',
            theme: "classic",
            templateResult: formatState,
            templateSelection: formatState,
            placeholder: 'Select an option'
        });
    }
    reinitializedMultipleSelect2();

    // description count
    // edit page count get
    let initialLength = $(".content").val().length;
    $(".textCountNumbers").text(initialLength);

    // create page count get
    $(".content").keyup(function(){
        $(".textCountNumbers").text($(this).val().length);
    });

    window.modal_close = function (){
        var modal = $('#create_category');
        modal.removeClass('show');
        $('body').removeClass('modal-open');
        var backdrop = $('.modal-backdrop');
        if (backdrop.length) {
            backdrop.remove();
        }
    }
});


